




    <nav class="navbar" >
      
      <!-- <a (click)="toggleSidebar($event)" class="sidebar-toggler" href="">
        <i class="feather icon-menu"></i>
      </a> -->
      <div class="navbar-content" style="width: 100%;">
        <form class="search-form">
          <div class="input-group">
            <div class="input-group-text">
              <!-- <i class="feather icon-search"></i> -->
            </div>
            
            <span class="inline">
              Welcome <strong>{{fullName | uppercase}}</strong>
              <!-- &nbsp;(<span class="text-muted">{{profileData?.Menu[0].ROLENAME || profileData?.ROLEID | uppercase}}</span>) -->
            </span>
            
          </div>
          <div class="timer">
            Logout in: {{ inactivityService.timeLeft$ | async }}
          </div>
        </form>
        <ul class="navbar-nav">
        
          <li class="nav-item nav-apps" hidden ngbDropdown>
            <a class="nav-link" id="appsDropdown" ngbDropdownToggle>
              <i class="link-icon feather icon-grid"></i>
            </a>
            <div aria-labelledby="appsDropdown" class="px-0" ngbDropdownMenu>
              <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                <p class="mb-0 fw-bold">Web Apps</p>
                <a class="text-muted" href="javascript:">Edit</a>
              </div>
              <div class="row g-0 p-1">
                <div class="col-3 text-center">
                  <a class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"
                     routerLink="/apps/chat"><i
                    class="feather icon-message-square icon-lg mb-1"></i>
                    <p class="tx-12">Chat</p></a>
                </div>
                <div class="col-3 text-center">
                  <a class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"
                     routerLink="/apps/calendar"><i
                    class="feather icon-calendar icon-lg mb-1"></i>
                    <p class="tx-12">Calendar</p></a>
                </div>
                <div class="col-3 text-center">
                  <a class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"
                     routerLink="/apps/email/inbox"><i
                    class="feather icon-mail icon-lg mb-1"></i>
                    <p class="tx-12">Email</p></a>
                </div>
                <div class="col-3 text-center">
                  <a class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"
                     routerLink="/general/profile"><i
                    class="feather icon-instagram icon-lg mb-1"></i>
                    <p class="tx-12">Profile</p></a>
                </div>
              </div>
              <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
                <a (click)="false" href="">View all</a>
              </div>
            </div>
          </li>
          <!-- <span id="google_translate_element"></span> -->
          <!-- <div id="google_translate_element" class="notranslate d-flex align-items-center justify-content-center mt-3">
            <button class="btn btn-primary"  style="margin-right: 20px; margin-top: -15px;" (click)="language()">Select Language</button>
          </div> -->
          <li class="nav-item nav-messages" hidden ngbDropdown>
            <a class="nav-link" id="messageDropdown" ngbDropdownToggle>
              <i class="link-icon feather icon-mail"></i>
            </a>
            <div aria-labelledby="messageDropdown" class="px-0" ngbDropdownMenu>
              <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                <p>9 New Messages</p>
                <a (click)="false" class="text-muted" href="">Clear all</a>
              </div>
              <div class="p-1">
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="me-3">
                    <img alt="user" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="me-4">
                      <p>Leonardo Payne</p>
                      <p class="tx-12 text-muted">Project status</p>
                    </div>
                    <p class="tx-12 text-muted">2 min ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="me-3">
                    <img alt="user" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="me-4">
                      <p>Carl Henson</p>
                      <p class="tx-12 text-muted">Client meeting</p>
                    </div>
                    <p class="tx-12 text-muted">30 min ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="me-3">
                    <img alt="user" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="me-4">
                      <p>Jensen Combs</p>
                      <p class="tx-12 text-muted">Project updates</p>
                    </div>
                    <p class="tx-12 text-muted">1 hrs ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="me-3">
                    <img alt="user" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="me-4">
                      <p>Amiah Burton</p>
                      <p class="tx-12 text-muted">Project deatline</p>
                    </div>
                    <p class="tx-12 text-muted">2 hrs ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="me-3">
                    <img alt="user" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="d-flex justify-content-between flex-grow-1">
                    <div class="me-4">
                      <p>Yaretzi Mayo</p>
                      <p class="tx-12 text-muted">New record</p>
                    </div>
                    <p class="tx-12 text-muted">5 hrs ago</p>
                  </div>
                </a>
              </div>
              <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
                <a (click)="false" href="">View all</a>
              </div>
            </div>
          </li>
          
          <li class="nav-item nav-notifications" hidden ngbDropdown>
            <a class="nav-link" id="notificationDropdown" ngbDropdownToggle>
              <i class="link-icon feather icon-bell"></i>
              <div class="indicator">
                <div class="circle"></div>
              </div>
            </a>
            <div aria-labelledby="notificationDropdown" class="px-0" ngbDropdownMenu>
              <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                <p>6 New Notifications</p>
                <a (click)="false" class="text-muted" href="">Clear all</a>
              </div>
              <div class="p-1">
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                    <i class="feather icon-gift icon-sm text-white"></i>
                  </div>
                  <div class="flex-grow-1 me-2">
                    <p>New Order Recieved</p>
                    <p class="tx-12 text-muted">30 min ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                    <i class="feather icon-alert-circle icon-sm text-white"></i>
                  </div>
                  <div class="flex-grow-1 me-2">
                    <p>Server Limit Reached!</p>
                    <p class="tx-12 text-muted">1 hrs ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                    <img alt="userr" class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30">
                  </div>
                  <div class="flex-grow-1 me-2">
                    <p>New customer registered</p>
                    <p class="tx-12 text-muted">2 sec ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                    <i class="feather icon-layers icon-sm text-white"></i>
                  </div>
                  <div class="flex-grow-1 me-2">
                    <p>Apps are ready for update</p>
                    <p class="tx-12 text-muted">5 hrs ago</p>
                  </div>
                </a>
                <a (click)="false" class="dropdown-item d-flex align-items-center py-2" href="">
                  <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                    <i class="feather icon-download icon-sm text-white"></i>
                  </div>
                  <div class="flex-grow-1 me-2">
                    <p>Download completed</p>
                    <p class="tx-12 text-muted">6 hrs ago</p>
                  </div>
                </a>
              </div>
              <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
                <a (click)="false" href="">View all</a>
              </div>
            </div>
          </li>
          
          <li class="nav-item nav-profile" ngbDropdown>
            <a class="nav-link" id="profileDropdown" ngbDropdownToggle>
              <div style="width: 120%;" class="text-center border border-white sidebar-brand nobleui-logo rounded-circle bg-secondary notranslate">
                <span  class="text-center sidebar-brand nobleui-logo text-light
                     ">{{this.Name}}</span></div>        </a>
            <div aria-labelledby="profileDropdown" class="px-0" ngbDropdownMenu>
              <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
                <!-- <div class="mb-3">
                  <div style="width: 120%;" class="text-center border border-white sidebar-brand nobleui-logo rounded-circle bg-secondary">
                    <span  class="text-center sidebar-brand nobleui-logo text-light
                         ">{{this.Name}}</span></div>            </div> -->
                <div class="text-center">
                  <p class="tx-16 fw-bolder capital">{{profileData?.fullName | uppercase}}</p>
                  <p class="tx-12 text-muted">{{profileData?.USERID}}</p>
                </div>
              </div>
              <ul class="list-unstyled p-1">
                <li class="dropdown-item py-2" hidden>
                  <a class="d-flex text-body ms-0" routerLink="/general/profile">
                    <i class="feather icon-user me-2 icon-md"></i>
                    <span>Profile</span>
                  </a>
                </li>
                <li class="dropdown-item py-2" hidden>
                  <a (click)="false" class="d-flex text-body ms-0" href="">
                    <i class="feather icon-edit me-2 icon-md"></i>
                    <span>Edit Profile</span>
                  </a>
                </li>
                <li class="dropdown-item py-2" hidden>
                  <a (click)="false" class="d-flex text-body ms-0" href="">
                    <i class="feather icon-repeat me-2 icon-md"></i>
                    <span>Switch User</span>
                  </a>
                </li>
                <li class="dropdown-item py-2">
                  <a (click)="onChangePassword($event)" class="d-flex text-body ms-0" href="">
                    <i class="feather icon-repeat me-2 icon-md"></i>
                    <span>Change Password</span>
                  </a>
                </li>
                <li class="dropdown-item py-2">
                  <a (click)="onLogout($event)" class="d-flex text-body ms-0" href="">
                    <i class="feather icon-log-out me-2 icon-md"></i>
                    <span>Log Out</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
